import { prepareQueryParams } from '@homeviews/utils'
import { api } from '../api'

import type { Review, FilterType } from '@homeviews/models'

interface IReviewResponse {
  data: Review[]
  meta: {
    current_page: number
    from: number
    last_page: number
    posts_per_page: number
    to: number
    total: number
  }
}

interface IFilterResponse {
  id: string
  name: string
}

export const reviewsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getReviews: builder.query<IReviewResponse, any>({
      query: (params) => {
        return {
          url: `/reviews${prepareQueryParams(params)}`,
        }
      },
      providesTags: <any>['Reviews'],
    }),
    getReviewsFilters: builder.query<
      IFilterResponse[],
      FilterType | { field: FilterType; developer?: number[] }
    >({
      query: (arg) => {
        const field = typeof arg === 'string' ? arg : arg.field
        const developer = typeof arg === 'string' ? undefined : arg.developer
        const params = developer?.length
          ? prepareQueryParams({ 'developer[]': developer })
          : ''
        return {
          url: `/reviews/options/${field}${params}`,
        }
      },
    }),
    createReviewReply: builder.mutation({
      query: ({ data }) => {
        return {
          url: `/replies`,
          method: 'POST',
          body: data,
        }
      },
      invalidatesTags: <any>['Reviews'],
    }),
    updateReviewReply: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `/replies/${id}`,
          method: 'PATCH',
          body: data,
        }
      },
      invalidatesTags: <any>['Reviews'],
    }),
    approveReviewReply: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `/replies/${id}/approve`,
          method: 'POST',
          body: data,
        }
      },
      invalidatesTags: <any>['Reviews'],
    }),
  }),
})

export const {
  useGetReviewsQuery,
  useGetReviewsFiltersQuery,
  useCreateReviewReplyMutation,
  useUpdateReviewReplyMutation,
  useApproveReviewReplyMutation,
} = reviewsApi
